import { Organization } from '@kaizenplatform/intelligence-entity';
import gql from 'graphql-tag';
import GraphQLClient from '../../adapter/GraphQLClient';

export enum PermissionAction {
  MEMBERSHIPS_READ = 'MEMBERSHIPS_READ',
  MEMBERSHIPS_WRITE = 'MEMBERSHIPS_WRITE',
  ORGANIZATIONS_READ = 'ORGANIZATIONS_READ',
  ORGANIZATIONS_WRITE = 'ORGANIZATIONS_WRITE',
}

class OrganizationWebApiId {
  private readonly graphqlClient: GraphQLClient;

  constructor({ idGraphqlClient }: { idGraphqlClient: GraphQLClient }) {
    this.graphqlClient = idGraphqlClient;
  }

  public getAllAvailableOrganizations = async (permissionActions: PermissionAction[]): Promise<Organization[]> => {
    const result = await this.graphqlClient.query(
      gql`
        query organizations($permissionActions: [OrganizationPermissionActionEnum!]) {
          organizations(permissionActions: $permissionActions) {
            id
            name
          }
        }
      `,
      { permissionActions },
    );
    return result.organizations.map((organization: Organization) => Organization.fromJSON(organization));
  };
}

export default OrganizationWebApiId;
